import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";

import Swal from "sweetalert2";

import {
  searchTour,
  getTours,
  getFilterMax,
} from "../../services/adminTourList";

import "./TourList.scss";

// import Modals from "./Modals";
import TabsContainer from "./TabsContainer";
import { FilterModal } from "./Modals";
import Loader from "utilities/Loader";

export default function TourList() {
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(true);
  const [priceOptions, setPriceOptions] = useState({
    max: 50000000,
    step: 500000,
  });
  const [filterInputs, setFilterInputs] = useState({
    title: "",
    priceRange: [0, 0],
    transferType: 0,
    duration: 0,
    stm: "",
    ftm: "",
  });

  async function search() {
    setLoading(true);
    let conditions = await searchTour(filterInputs);
    getInfo(conditions);
  }

  async function resetFilters() {
    setFilterInputs({
      title: "",
      priceRange: [0, priceOptions.max],
      transferType: 0,
      duration: 0,
      stm: "",
      ftm: "",
    });
  }

  async function getInfo(conditions = "") {
    let tours = await getTours(conditions);
    if (conditions != "" && tours.length == 0) {
      await Swal.fire({
        title: "خطا!",
        text: "توری با این مشخصات موجود نمیباشد. لطفا مشخصات صحیح را وارد نمایید.",
        icon: "error",
        showConfirmButton: true,
        confirmButtonText: "باشه",
      });
    } else {
      setTours(tours);
    }
    setLoading(false);
  }

  useEffect(() => {
    async function loadPage() {
      let res = await getFilterMax();
      setPriceOptions({ ...priceOptions, max: res });
      setFilterInputs({ ...filterInputs, priceRange: [0, res] });
      await getInfo();
    }
    loadPage();
  }, []);

  return (
    <>
      <div className="container tour-list-container">
        {/* title */}
        <div
          style={{ fontFamily: '"bold"' }}
          className="fs-5 color-green pt-3 mb-3"
        >
          تورها
        </div>
        {/* tour list */}
        {loading ? <Loader /> : ""}
        <ul className="nav nav-tabs mb-3" id="nav-tab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link text active"
              id="first-id-tab"
              data-bs-toggle="pill"
              data-bs-target="#first-id"
              type="button"
              role="tab"
              aria-controls="first-id"
              aria-selected="true"
            >
              درحال برنامه ریزی
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link text"
              id="second-id-tab"
              data-bs-toggle="pill"
              data-bs-target="#second-id"
              type="button"
              role="tab"
              aria-controls="second-id"
              aria-selected="false"
            >
              در حال رزرو
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link text"
              id="third-id-tab"
              data-bs-toggle="pill"
              data-bs-target="#third-id"
              type="button"
              role="tab"
              aria-controls="third-id"
              aria-selected="false"
            >
              در حال اجرا
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link text"
              id="fourth-id-tab"
              data-bs-toggle="pill"
              data-bs-target="#fourth-id"
              type="button"
              role="tab"
              aria-controls="fourth-id"
              aria-selected="false"
            >
              اجرا شده
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link text"
              id="fifth-id-tab"
              data-bs-toggle="pill"
              data-bs-target="#fifth-id"
              type="button"
              role="tab"
              aria-controls="fifth-id"
              aria-selected="false"
            >
              اجرا نشده
            </button>
          </li>

          <li className="nav-item" role="presentation">
            <button
              className="nav-link text"
              id="sixth-id-tab"
              data-bs-toggle="pill"
              data-bs-target="#sixth-id"
              type="button"
              role="tab"
              aria-controls="sixth-id"
              aria-selected="false"
            >
              دسته بندی تور
            </button>
          </li>
        </ul>
        <div className="tab-content" id="nav-tabContent">
          <TabsContainer tours={tours} getInfo={getInfo} />
        </div>
      </div>
      {/* <Modals /> */}
      {ReactDOM.createPortal(
        <FilterModal
          filterInputs={filterInputs}
          setFilterInputs={setFilterInputs}
          priceOptions={priceOptions}
          search={search}
          resetFilters={resetFilters}
        />,
        document.querySelector(".modals")
      )}
    </>
  );
}
